import { FindDashboardItemDTO, FindItem, FindItemsDTO } from "@dto/dashboard.dto";
import TableDashboardSelect from "@parts/table/TableDashboardSelect";
import { Button, Tooltip } from "antd";
import { FC, useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import { API_URL } from "src/data/Api";
import { Log } from "src/service/log.service";
import { postApi } from "src/util/apiCalls";
import "./TableUtil.less";
import { IconSize } from "./XmResetFilterIcon";

export interface XmDashboardStarIconProps {
  size?: IconSize;
  disabled?: boolean;
  selectProps: {
    tabName: string;
    subTabName: string;
    tabId: string;
    dashUrl: string;
    id: string;
  };
}

export const XmTableDashboardStarIcon: FC<XmDashboardStarIconProps> = ({ size = "normal", disabled, selectProps }) => {
  const [timestamp, setTimestamp] = useState(0);
  const [dashboardItems, setDashboardItems] = useState<FindItem[]>([]);

  useEffect(() => {
    const searchBody: FindDashboardItemDTO = {
      tab: selectProps.tabName, subtab: selectProps.subTabName, tabId: selectProps.tabId,
      url: selectProps.dashUrl, type: 'capacity_table'
    };
    postApi<FindItemsDTO, FindDashboardItemDTO>(API_URL.DASHBOARD_FIND_ITEM, searchBody).then(response => {
      setDashboardItems(response.data.data);
    }, reason => Log.error('Failed to get table dashboards!', reason));
  }, []);

  return <>
    <Tooltip title="Manage in dashboards">
      <a
        onClick={() => setTimestamp(Date.now())}
        className={"xm-tbl-star " + (disabled || !dashboardItems?.length ? "xm-tbl-not-dash" : "xm-tbl-in-dash")}
      >
        <FaStar className={`xm-icon xm-icon-${size}`} />
      </a>
    </Tooltip>
    <TableDashboardSelect type="capacity_table" common={{ ...selectProps, dashboardItems, setDashboardItems }} timestamp={timestamp} id={selectProps.id} />
  </>;
};

interface XmAlertTableDashboardStarIconProps {
  disabled?: boolean;
  findItems: FindItem[];
  alertingGroupID: string;
  /** User group the alert is shared with, if any. */
  shareGroupId?: number;
}

// TODO: unify with XmTableDashboardStarIcon
export const XmAlertTableDashboardStarIcon: FC<XmAlertTableDashboardStarIconProps> = ({ findItems, disabled, alertingGroupID, shareGroupId }) => {
  const [timestamp, setTimestamp] = useState(0);
  const [dashboardItems, setDashboardItems] = useState<FindItem[]>(() => findItems.filter(fg => fg.alerting_group_id === alertingGroupID));

  // saving creates alerts anew, so their ids have to come from the server - the create response carries the table id
  const reloadDashboardItems = () => {
    postApi<FindItemsDTO, FindDashboardItemDTO>(API_URL.DASHBOARD_FIND_ITEM, { type: 'alerting_table' }).then(response => {
      setDashboardItems(response.data.data.filter(fg => fg.alerting_group_id === alertingGroupID));
    }, reason => Log.error('Failed to get alert dashboards!', reason));
  };

  return <>
    <Tooltip title="Manage in dashboards">
      <Button
        type="text"
        className={"xm-tbl-star " + (disabled || !dashboardItems?.length ? "xm-tbl-not-dash" : "xm-tbl-in-dash")}
        icon={<FaStar className="xm-icon xm-icon-normal" />}
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          setTimestamp(Date.now());
        }}
      />
    </Tooltip>
    <span onClick={e => e.stopPropagation()}>
      <TableDashboardSelect type="alerting_table" common={{ dashboardItems, setDashboardItems: reloadDashboardItems }} timestamp={timestamp} id={alertingGroupID} shareGroupId={shareGroupId} />
    </span>
  </>;
}

